import { MEDIA_ASSET_STATUS } from '@socialive/common';

/* eslint-disable no-param-reassign */
export default (state, action) => {
  const { sessionHash } = action.meta.arg;
  state.assets[sessionHash] ??= { sessionHash };
  state.assets[sessionHash].status = MEDIA_ASSET_STATUS.FAILED;
};
